import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { IS_LOADING, SHOW_SNACKBAR } from "../../utils/types";
import { useRef, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { uploadFile } from "../../store/actions/globalAction";

export default function AttachmentPopup({ onClose, setUploadFileData, selectedContact, wabaId }) {
    let dispatch = useDispatch();
    const options = [
        { label: "Document", icon: "📄", type: "document", color: "bg-gray-50" },
        { label: "Gallery", icon: "🖼", type: "image", color: "bg-gray-50" },
        { label: "Camera", icon: "📷", type: "image", color: "bg-gray-50" },
        { label: "Video", icon: "🎥", type: "video", color: "bg-gray-50" },
        //{ label: "Audio", icon: "🎧", type: "audio", color: "bg-gray-50" },
    ];
    const [type, setType] = useState();
    const [uploading, setUploading] = useState(false);
    const imageInputRef = useRef(null);
    const globalReducer = useSelector((state) => state.globalReducer);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) {
            dispatch({
                type: SHOW_SNACKBAR,
                payload: {
                    type: "error",
                    message: "Please select a file.",
                    open: true,
                },
            });
            return;
        }
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const allowedFormats = type === "image" ? ["png", "jpg", "jpeg"] : type === "video" ? ["mp4", "mov", "avi"] : type === "audio" ? ["audio/*"] : ["pdf", "doc", "docx", "xls", "xlsx", "txt"];

        if (!allowedFormats.includes(fileExtension)) {
            dispatch({
                type: SHOW_SNACKBAR,
                payload: {
                    type: "error",
                    message: "Invalid file format. Please upload an " + allowedFormats.join(", ") + " file.",
                    open: true,
                },
            });
            return;
        }
        try {
            const newUuid = uuidv4();
            const key = `weblivechat/${globalReducer.loginInfo?.tenantId}/${wabaId}/${newUuid}.${file.name.split('.').pop()}`;
            const formData = new FormData();
            formData.append('file', file);
            dispatch(uploadFile(formData, key, a => {
                setUploading(false);
                if (a) {
                    setUploadFileData({
                        url: key,
                        mediaType: file.type,
                        filename: file.name,
                        type: type
                    });
                } else {
                    setUploading(false);
                }
            }));
        } catch (error) {
            console.error("Error parsing file:", error);
        }
    };

    const openGallery = () => {
        imageInputRef.current.click();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-end bg-black/40">
            <div
                className="absolute inset-0"
                onClick={onClose}
            />
            <div className="relative w-full bg-white rounded-t-2xl p-4 animate-slideUp">
                <div className="grid grid-cols-3 gap-4">
                    {options.map((opt) => (
                        <button key={opt.label} type="button" className="flex flex-col items-center gap-2" onClick={async () => {
                            await setType(opt.type);
                            openGallery();
                        }}>
                            <div className={`${opt.color} text-white w-14 h-14 rounded-full flex items-center justify-center text-2xl`}>
                                {opt.icon}
                            </div>
                            <span className="text-xs text-gray-700">{opt.label}</span>
                        </button>
                    ))}
                    <input
                        ref={imageInputRef}
                        type="file"
                        accept={type === "image" ? ".png, .jpg, .jpeg" : type === "video" ? ".mp4, .mov, .avi" : type === "audio" ? "audio/*" : ".pdf, .doc, .docx, .xls, .xlsx, .txt"}
                        className="hidden"
                        onChange={handleFileChange}
                    />
                </div>
            </div>
        </div>
    );
}
